import { useEffect } from 'react';
const KEY_LAST_NPS_LOADED = '@lastNpsLoaded';
const KEY_AUTH_NPS_TOKEN = 'kcIdToken';
const useLoadNps = ({ mfeStage, currentMfeState, nps, userData, tenant, userProfile, }) => {
    const getNpsLocalStorageValue = (keyPrefix) => {
        const key = Object.keys(localStorage).find((k) => k.startsWith(keyPrefix));
        return key ? { key, value: localStorage.getItem(key) || '' } : null;
    };
    const setOptionalVarsNps = () => {
        if (nps?.group)
            localStorage.setItem('npsGroup', nps?.group);
        if (nps?.unitCode)
            localStorage.setItem('npsUnitCode', nps?.unitCode);
    };
    const getNpsMeta = () => {
        if (!userProfile.profile) {
            return null;
        }
        return { tenant: tenant.currentTenant, ...userProfile.profile };
    };
    const removeVarsNps = () => {
        const npsSkip = getNpsLocalStorageValue('npsSkip');
        const npsClose = getNpsLocalStorageValue('npsClose');
        const npsGroup = getNpsLocalStorageValue('npsGroup');
        const npsUnitCode = getNpsLocalStorageValue('npsUnitCode');
        if (npsSkip)
            localStorage.removeItem(npsSkip.key);
        if (npsClose)
            localStorage.removeItem(npsClose.key);
        if (npsGroup)
            localStorage.removeItem('npsGroup');
        if (npsUnitCode)
            localStorage.removeItem('npsUnitCode');
    };
    const updateNpsLocalStorage = () => {
        if (!nps)
            return;
        const storedData = localStorage.getItem(KEY_LAST_NPS_LOADED);
        if (!storedData)
            return;
        try {
            const parsedData = JSON.parse(storedData);
            const userNpsData = parsedData[nps.productId]?.[userData.userName];
            if (userNpsData?.npsSkip) {
                localStorage.setItem(userNpsData.npsSkip.key, userNpsData.npsSkip.value);
            }
            if (userNpsData?.npsClose) {
                localStorage.setItem(userNpsData.npsClose.key, userNpsData.npsClose.value);
            }
        }
        catch (error) {
            console.error('Erro ao processar localStorage:', error);
        }
    };
    const removeNpsScript = () => {
        if (!nps)
            return;
        const npsSkip = getNpsLocalStorageValue('npsSkip');
        const npsClose = getNpsLocalStorageValue('npsClose');
        if (!npsSkip && !npsClose)
            return;
        const storedData = localStorage.getItem(KEY_LAST_NPS_LOADED);
        const parsedData = storedData
            ? JSON.parse(storedData)
            : {};
        if (!parsedData[nps.productId]) {
            parsedData[nps.productId] = {};
        }
        if (!parsedData[nps.productId][userData.userName]) {
            parsedData[nps.productId][userData.userName] = {};
        }
        if (npsSkip)
            parsedData[nps.productId][userData.userName].npsSkip = npsSkip;
        if (npsClose)
            parsedData[nps.productId][userData.userName].npsClose = npsClose;
        localStorage.setItem(KEY_LAST_NPS_LOADED, JSON.stringify(parsedData));
        removeVarsNps();
    };
    const injectNpsScript = () => {
        if (!nps)
            return;
        if (!userProfile.profile)
            return;
        removeVarsNps();
        updateNpsLocalStorage();
        setOptionalVarsNps();
        const iframe = mfeStage.contentWindow.document.body;
        const metaData = getNpsMeta();
        const script = document.createElement('script');
        script.id = 'nps-script';
        script.src = nps.baseApi;
        script.setAttribute('host', nps.host);
        script.setAttribute('productId', nps.productId);
        script.setAttribute('auth', KEY_AUTH_NPS_TOKEN);
        script.setAttribute('storage', 'local');
        script.setAttribute('group', 'npsGroup');
        script.setAttribute('unitCode', 'npsUnitCode');
        script.setAttribute('metadata', JSON.stringify(metaData));
        script.async = true;
        script.onload = () => console.log('Script NPS carregado!');
        iframe.appendChild(script);
    };
    useEffect(() => {
        if (currentMfeState === 'LOADED' &&
            nps &&
            !nps.hide &&
            userProfile.profile) {
            injectNpsScript();
            return removeNpsScript;
        }
    }, [currentMfeState, nps, userProfile]);
};
export default useLoadNps;
//# sourceMappingURL=use-load-nps.js.map